// Renders where a cart line is going: the pickup store, or the delivery address.
//
// The pickup store used to ride each line as a `_pickup_at` line-item property, which meant it froze
// at add-to-cart time and went stale whenever the buyer changed store later — including at checkout,
// where it then misled fulfilment staff on the placed order (FPS-682). The delivery address was
// never shown at all, so a delivery line gave the buyer no way to see which address it would go to.
//
// A cart is single-method / single-location, so both values are cart-wide, not per-line. They are
// read here from the cookies the location and address drawers already own.
if (!customElements.get('cart-fulfilment-location')) {
  customElements.define(
    'cart-fulfilment-location',
    class CartFulfilmentLocation extends HTMLElement {
      connectedCallback() {
        this.render();
        this._onLocationChanged = () => this.render();
        document.addEventListener('location:changed', this._onLocationChanged);
        document.addEventListener('deliveryAddress:updated', this._onLocationChanged);
      }

      disconnectedCallback() {
        document.removeEventListener('location:changed', this._onLocationChanged);
        document.removeEventListener('deliveryAddress:updated', this._onLocationChanged);
      }

      render() {
        this.textContent = this.locationName() || '';
      }

      locationName() {
        return this.getAttribute('method') === 'delivery' ? this.deliveryAddress() : this.pickupStoreName();
      }

      pickupStoreName() {
        const parsed = this.readCookie('locationDrawerSelected');
        if (!parsed) return null;
        // Two historical shapes, same as location-status.js / checkout-delivery-preference.js:
        //   legacy flat → { latitude, longitude, name }
        //   per-method  → { pickup: { ... }, ... }
        const selection = parsed.latitude === undefined && parsed.pickup ? parsed.pickup : parsed;
        return selection?.name?.trim() || null;
      }

      deliveryAddress() {
        const parsed = this.readCookie('addressDrawerResult');
        return parsed?.formatted_address?.trim() || parsed?.name?.trim() || null;
      }

      readCookie(name) {
        const prefix = name + '=';
        const cookies = document.cookie ? document.cookie.split('; ') : [];
        const cookie = cookies.find((entry) => entry.startsWith(prefix));
        if (!cookie) return null;

        try {
          return JSON.parse(decodeURIComponent(cookie.substring(prefix.length)));
        } catch {
          return null;
        }
      }
    },
  );
}
